export class TooManyRequestsError extends Error {
  constructor() {
    super('Too many requests. Try again later');
  }
}
